import SocialMedia from '@components/social-media/SocialMedia';



const NotFoundPage = (): JSX.Element => {

	return (
		<div className="app-page not-found-page">
			
			<h1>Něco se pokazilo...</h1>

			<div className='info-text'>
				<p>Požadovaná stránka nenalezena</p>
			</div>

			<SocialMedia />

		</div>
	);
};

export default NotFoundPage;